import { PINLockPlayerPopup } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { useCallback } from 'react'
import { resetUnlockId, $unlockedId, unlockId } from '../../content'
import {
  $isValidPinCode,
  $pinLockPopup,
  $pinLockPopupDescription,
  autoSubmitPinCode,
  changePinCode,
  closePinLockPopup,
  resetValidPinCode,
} from '../model'

export const usePinLockPlayerPopup = (title: string) => {
  const closePinLockPopupEvent = useUnit(closePinLockPopup)
  const eventAutoSubmitPinCode = useUnit(autoSubmitPinCode)
  const eventChangePinCode = useUnit(changePinCode)
  const isValidPinCode = useUnit($isValidPinCode)
  const pinLockDescription = useUnit($pinLockPopupDescription)
  const pinLockPopup = useUnit($pinLockPopup)
  const resetUnlockIdEvent = useUnit(resetUnlockId)
  const resetValidPinCodeEvent = useUnit(resetValidPinCode)
  const unlockedChannelId = useUnit($unlockedId)
  const updateUnlockId = useUnit(unlockId)

  const autoSubmitPinCodeCallback = useCallback(
    (value: string) => {
      eventAutoSubmitPinCode({ value })
    },
    [eventAutoSubmitPinCode]
  )

  const changePinCodeCallback = useCallback(
    (value: string) => {
      eventChangePinCode({ value })
    },
    [eventChangePinCode]
  )

  const PINLockPlayerPopupComponent = useCallback(
    () => (
      <PINLockPlayerPopup
        title={title}
        description={pinLockDescription}
        invalid={pinLockPopup.invalid}
        errorMessage={pinLockPopup.errorMessage}
        onCompleteInput={autoSubmitPinCodeCallback}
        onChangeInput={changePinCodeCallback}
        valueAfterInvalid={pinLockPopup.valueAfterInvalid}
      />
    ),
    [
      autoSubmitPinCodeCallback,
      changePinCodeCallback,
      pinLockDescription,
      pinLockPopup.errorMessage,
      pinLockPopup.invalid,
      pinLockPopup.valueAfterInvalid,
      title,
    ]
  )

  return {
    closePinLockPopup: closePinLockPopupEvent,
    isValidPinCode,
    PINLockPlayerPopupComponent,
    resetUnlockId: resetUnlockIdEvent,
    resetValidPinCode: resetValidPinCodeEvent,
    unlockedChannelId,
    updateUnlockId,
  }
}
